export enum TypeOfSupportEnum {
  viewPlan,
  viewSim,
  apiDoc,
  officialDispatch,
}
